import React from 'react';
import { BrandedLoading } from '../BrandedLoading';
import './PracticeLoadingScreen.css';

export const PracticeLoadingScreen: React.FC = () => {
  return (
    <div className="practice-loading-screen">
      <BrandedLoading context="practice" />
    </div>
  );
};
